// import {
//   AvatarDropdown,
//   AvatarName,
//   Footer,
//   Question,
//   SelectLang,
// } from "@/components";
// import { LinkOutlined } from "@ant-design/icons";
// import type { Settings as LayoutSettings } from "@ant-design/pro-components";
// import { SettingDrawer } from "@ant-design/pro-components";
// import type { RequestConfig, RunTimeLayoutConfig } from "@umijs/max";
// import { history, Link } from "@umijs/max";

// import "@ant-design/v5-patch-for-react-19";
// import defaultSettings from "../config/defaultSettings";
// import { errorConfig } from "./requestErrorConfig";
// import { currentUser } from "./services/eb/api";

// const isDev = process.env.NODE_ENV === "development" || process.env.CI;
// const loginPath = "/user/login";

// /**
//  * @see https://umijs.org/docs/api/runtime-config#getinitialstate
//  * */
// export async function getInitialState(): Promise<{
//   settings?: Partial<LayoutSettings>;
//   currentUser?: API.CurrentUser | any;
//   loading?: boolean;
//   fetchUserInfo?: () => Promise<API.CurrentUser | undefined | any>;
// }> {
//   const fetchUserInfo = async () => {
//     try {
//       const msg = await currentUser({
//         skipErrorHandler: true,
//       });
//       // console.log(msg)
//       return msg;
//     } catch (_error) {
//       if (
//         ![
//           loginPath,
//           "/user/register",
//           // '/user/register-result',
//           // '/auth/activate',
//           // '/auth/confirm-email',
//         ].includes(location.pathname) &&
//         !history.location.pathname.startsWith("/users/")
//       ) {
//         history.push(loginPath);
//       }
//     }
//     return undefined;
//   };

//   const { location } = history;
//   if (
//     ![
//       loginPath,
//       "/user/register",
//       // '/user/register-result',
//       // '/auth/activate',
//       // '/auth/confirm-email',
//     ].includes(location.pathname) &&
//     !location.pathname.startsWith("/users/")
//   ) {
//     const currentUser = await fetchUserInfo();
//   return {
//     fetchUserInfo,
//       currentUser,
//     settings: defaultSettings as Partial<LayoutSettings>,
//   };
// }
//   return {
//     fetchUserInfo,
//     settings: defaultSettings as Partial<LayoutSettings>,
//   };
// }

// // ProLayout 支持的api https://procomponents.ant.design/components/layout
// export const layout: RunTimeLayoutConfig = ({
//   initialState,
//   setInitialState,
// }) => {
//   return {
//     actionsRender: () => [
//       <Question key="doc" />,
//       <SelectLang key="SelectLang" />,
//     ],
//     avatarProps: {
//       src: initialState?.currentUser?.avatar,
//       title: <AvatarName />,
//       render: (_, avatarChildren) => {
//         return <AvatarDropdown>{avatarChildren}</AvatarDropdown>;
//       },
//     },
//     waterMarkProps: {
//       content: initialState?.currentUser?.name,
//     },
//     footerRender: () => <Footer />,
//     onPageChange: () => {
//       // const { location } = history;
//       // 如果没有登录，重定向到 login
//       if (
//         !initialState?.currentUser &&
//         location.pathname !== loginPath &&
//         !location.pathname.startsWith("/users/")
//       ) {
//         history.push(loginPath);
//       }
//     },
//     bgLayoutImgList: [
//       {
//         src: "https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/D2LWSqNny4sAAAAAAAAAAAAAFl94AQBr",
//         left: 85,
//         bottom: 100,
//         height: "303px",
//       },
//       {
//         src: "https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/C2TWRpJpiC0AAAAAAAAAAAAAFl94AQBr",
//         bottom: -68,
//         right: -45,
//         height: "303px",
//       },
//       {
//         src: "https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/F6vSTbj8KpYAAAAAAAAAAAAAFl94AQBr",
//         bottom: 0,
//         left: 0,
//         width: "331px",
//       },
//     ],
//     links: isDev
//       ? [
//           <Link key="openapi" to="/umi/plugin/openapi" target="_blank">
//             <LinkOutlined />
//             <span>OpenAPI 文档</span>
//           </Link>,
//         ]
//       : [],
//     menuHeaderRender: undefined,
//     // 自定义 403 页面
//     // unAccessible: <div>unAccessible</div>,
//     // 增加一个 loading 的状态
//     childrenRender: (children) => {
//       // if (initialState?.loading) return <PageLoading />;
//       return (
//         <>
//           {children}
//           {isDev && (
//             <SettingDrawer
//               disableUrlParams
//               enableDarkTheme
//               settings={initialState?.settings}
//               onSettingChange={(settings) => {
//                 setInitialState((preInitialState) => ({
//                   ...preInitialState,
//                   settings,
//                 }));
//               }}
//             />
//           )}
//         </>
//       );
//     },
//     ...initialState?.settings,
//   };
// };

// /**
//  * @name request 配置，可以配置错误处理
//  * 它基于 axios 和 ahooks 的 useRequest 提供了一套统一的网络请求和错误处理方案。
//  * @doc https://umijs.org/docs/max/request#配置
//  */
// export const request: RequestConfig = {
//   baseURL: API_BASE_URL,
//   ...errorConfig,
// };

import {
  AvatarDropdown,
  AvatarName,
  Footer,
  Question,
  SelectLang,
} from "@/components";
import { LinkOutlined } from "@ant-design/icons";
import type { Settings as LayoutSettings } from "@ant-design/pro-components";
import { SettingDrawer } from "@ant-design/pro-components";
import type { RequestConfig, RunTimeLayoutConfig } from "@umijs/max";
import { history, Link } from "@umijs/max";

import "@ant-design/v5-patch-for-react-19";
import defaultSettings from "../config/defaultSettings";
import { errorConfig } from "./requestErrorConfig";
import { currentUser } from "./services/eb/api";

export function rootContainer(container: JSX.Element) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      {/* 🎄 Lights Section:takes up physical space 🎄 */}
      {/* <div
        style={{
          width: '100%',
          backgroundColor: 'transparent',
          zIndex: 9999,
          flexShrink: 0, 
          textAlign: 'center',
          lineHeight: 0, 
        }}
      >
        <img
          src="/christmas lightsZ.png"
          alt="Season's Greetings"
          style={{
            width: '100%',
            height: 'auto',
            maxHeight: '150px', 
            objectFit: 'cover',
            objectPosition: 'top',
          }}
        />
      </div> */}
      <div style={{ flex: 1, position: 'relative', overflow: 'auto' }}>
        {container}
      </div>
    </div>
  );
}

const isDev = process.env.NODE_ENV === "development" || process.env.CI;
const loginPath = "/user/login";

/**
 * Public paths that don't require the user to be logged in.
 * Add any other public routes here (e.g. marketing pages, docs).
 */
const PUBLIC_PATHS = [
  loginPath,
  "/user/register",
  "/terms",
  "/terms.html",
  "/privacy",
  "/privacy.html",
];

const isPublicPath = (pathname?: string) => {
  if (!pathname) return false;
  return PUBLIC_PATHS.some((p) => pathname === p || pathname.startsWith(p));
};

/**
 * @see https://umijs.org/docs/api/runtime-config#getinitialstate
 * */
export async function getInitialState(): Promise<{
  settings?: Partial<LayoutSettings>;
  currentUser?: API.CurrentUser | any;
  loading?: boolean;
  fetchUserInfo?: () => Promise<API.CurrentUser | undefined | any>;
}> {
  const fetchUserInfo = async () => {
    try {
      const msg = await currentUser({
        skipErrorHandler: true,
      });
      // console.log(msg)
      return msg;
    } catch (_error) {
      // only redirect to login if current path is NOT public and not under /users/
      const path = history.location.pathname;
      if (!isPublicPath(path) && !path.startsWith("/users/")) {
        history.push(loginPath);
      }
    }
    return undefined;
  };

  const { location } = history;
  if (
    !isPublicPath(location.pathname) &&
    !location.pathname.startsWith("/users/")
  ) {
    const currentUser = await fetchUserInfo();
    return {
      fetchUserInfo,
      currentUser,
      settings: defaultSettings as Partial<LayoutSettings>,
    };
  }
  return {
    fetchUserInfo,
    settings: defaultSettings as Partial<LayoutSettings>,
  };
}

// ProLayout 支持的api https://procomponents.ant.design/components/layout
export const layout: RunTimeLayoutConfig = ({
  initialState,
  setInitialState,
}) => {
  return {
    actionsRender: () => [
      <Question key="doc" />,
      <SelectLang key="SelectLang" />,
    ],
    avatarProps: {
      src: initialState?.currentUser?.avatar,
      title: <AvatarName />,
      render: (_, avatarChildren) => {
        return <AvatarDropdown>{avatarChildren}</AvatarDropdown>;
      },
    },
    waterMarkProps: {
      content: initialState?.currentUser?.name,
    },
    footerRender: () => <Footer />,
    onPageChange: () => {
      // 如果没有登录，重定向到 login — but skip public paths
      const path = history.location.pathname;
      if (
        !initialState?.currentUser &&
        !isPublicPath(path) &&
        !path.startsWith("/users/")
      ) {
        history.push(loginPath);
      }
    },
    bgLayoutImgList: [
      {
        src: "https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/D2LWSqNny4sAAAAAAAAAAAAAFl94AQBr",
        left: 85,
        bottom: 100,
        height: "303px",
      },
      {
        src: "https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/C2TWRpJpiC0AAAAAAAAAAAAAFl94AQBr",
        bottom: -68,
        right: -45,
        height: "303px",
      },
      {
        src: "https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/F6vSTbj8KpYAAAAAAAAAAAAAFl94AQBr",
        bottom: 0,
        left: 0,
        width: "331px",
      },
    ],
    links: isDev
      ? [
          <Link key="openapi" to="/umi/plugin/openapi" target="_blank">
            <LinkOutlined />
            <span>OpenAPI 文档</span>
          </Link>,
        ]
      : [],
    menuHeaderRender: undefined,
    // 自定义 403 页面
    // unAccessible: <div>unAccessible</div>,
    // 增加一个 loading 的状态
    childrenRender: (children) => {
      // if (initialState?.loading) return <PageLoading />;
      return (
        <>
          {children}
          {isDev && (
            <SettingDrawer
              disableUrlParams
              enableDarkTheme
              settings={initialState?.settings}
              onSettingChange={(settings) => {
                setInitialState((preInitialState) => ({
                  ...preInitialState,
                  settings,
                }));
              }}
            />
          )}
        </>
      );
    },
    ...initialState?.settings,
  };
};

/**
 * @name request 配置，可以配置错误处理
 * 它基于 axios 和 ahooks 的 useRequest 提供了一套统一的网络请求和错误处理方案。
 * @doc https://umijs.org/docs/max/request#配置
 */
export const request: RequestConfig = {
  baseURL: API_BASE_URL,
  ...errorConfig,
};
